import WRAP from "WRAP-JS";
import * as ConfigRadar from "./config/ConfigRadar";
import { _orderBy, formatUTCDate, parseUTCDate } from "../../../utils/FPEUtils";
import LegendRadar from "../legend/LegendRadar";
import { WX_ID_RADAR } from "../../../store/WeatherContentsState";

export const RADAR_TYPE_JP = 'Japan';
export const RADAR_TYPE_KR = 'Korea';
export const RADAR_TYPE_TW = 'Taiwan';
export const RADAR_TYPE_US_AK = 'US-AK';
export const RADAR_TYPE_US_GU = 'US-GU';
export const RADAR_TYPE_US_HI = 'US-HI';
export const RADAR_TYPE_US_NA = 'US-NA';
export const RADAR_TYPE_US_PR = 'US-PR';
export const RADAR_TYPE_CA = 'Canada';
export const RADAR_TYPE_EU = 'EU'
export const RADAR_TYPE_AU = 'Australia';
export const RADAR_TYPE_ASIA = `${RADAR_TYPE_JP}|${RADAR_TYPE_KR}|${RADAR_TYPE_TW}`;
export const RADAR_TYPE_US = `${RADAR_TYPE_US_AK}|${RADAR_TYPE_US_GU}|${RADAR_TYPE_US_HI}|${RADAR_TYPE_US_NA}|${RADAR_TYPE_US_PR}`;

class Radar {
  static NAME = WX_ID_RADAR;
  dataType;
  changeDataTypeFlg = false;
  // 日本
  dhJP;
  layerJP;
  // アメリカ(AK)
  dhUSAK;
  layerUSAK;
  // アメリカ(GU)
  dhUSGU;
  layerUSGU;
  // アメリカ(HI)
  dhUSHI;
  layerUSHI;
  // アメリカ(NA)
  dhUSNA;
  layerUSNA;
  // アメリカ(PR)
  dhUSPR;
  layerUSPR;
  // ヨーロッパ
  dhEU;
  layerEU;
  // オーストラリア
  dhAU;
  layerAU;
  // 韓国
  dhKR;
  layerKR;
  // 台湾(カバレッジ無し)
  dhTW;
  layerTW;
  // カナダ
  dhCA;
  layerCA;

  areaInitialized = {
    [RADAR_TYPE_JP]: false,
    [RADAR_TYPE_KR]: false,
    [RADAR_TYPE_TW]: false,
    [RADAR_TYPE_US]: false,
    [RADAR_TYPE_CA]: false,
    [RADAR_TYPE_EU]: false,
    [RADAR_TYPE_AU]: false,
    [RADAR_TYPE_ASIA]: false,
    [RADAR_TYPE_US]: false
  };

  areaValidtimeInfo = {
    [RADAR_TYPE_JP]: '---',
    [RADAR_TYPE_KR]: '---',
    [RADAR_TYPE_TW]: '---',
    [RADAR_TYPE_US_AK]: '---',
    [RADAR_TYPE_US_GU]: '---',
    [RADAR_TYPE_US_HI]: '---',
    [RADAR_TYPE_US_NA]: '---',
    [RADAR_TYPE_US_PR]: '---',
    [RADAR_TYPE_CA]: '---',
    [RADAR_TYPE_EU]: '---',
    [RADAR_TYPE_AU]: '---',
  };

  coverage;

  ready = false;
  etd;
  elapsed = 0;
  dispatcher;
  visible;

  constructor() {
    this.dataType = RADAR_TYPE_ASIA;
    this.coverage = true;

    this.layerJP = new WRAP.Geo.Layer("RadarJP_ICDB");
    this.layerUSAK = new WRAP.Geo.Layer("RadarUSAK");
    this.layerUSGU = new WRAP.Geo.Layer("RadarUSGU");
    this.layerUSHI = new WRAP.Geo.Layer("RadarUSHI");
    this.layerUSNA = new WRAP.Geo.Layer("RadarUSNA");
    this.layerUSPR = new WRAP.Geo.Layer("RadarUSPR");
    this.layerEU = new WRAP.Geo.Layer("RadarEU");
    this.layerAU = new WRAP.Geo.Layer("RadarAU");
    this.layerKR = new WRAP.Geo.Layer("RadarKR");
    this.layerTW = new WRAP.Geo.Layer("RadarTW");
    this.layerCA = new WRAP.Geo.Layer("RadarCA_ICDB");
    this.layerJP.setVisible(false);
    this.layerUSAK.setVisible(false);
    this.layerUSGU.setVisible(false);
    this.layerUSHI.setVisible(false);
    this.layerUSNA.setVisible(false);
    this.layerUSPR.setVisible(false);
    this.layerEU.setVisible(false);
    this.layerAU.setVisible(false);
    this.layerKR.setVisible(false);
    this.layerTW.setVisible(false);
    this.layerCA.setVisible(false);
    //日本 韓国 台湾、グアムのカバレッジをマージする
    this.layerJP.merge([this.layerKR, this.layerTW, this.layerUSGU]);

    //アメリカ、カナダのカバレッジをマージする
    this.layerCA.merge([this.layerUSNA, this.layerUSAK, this.layerUSHI, this.layerUSPR]);
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
  }

  async initialize(dataType) {
    await this.initData(dataType);
    this.initLayer(dataType);
    this.ready = true;
  }

  initData(dataType) {
    return new Promise(resolve => {
      let dh;
      let promises;

      switch (dataType) {
        case RADAR_TYPE_JP:
          dh = this.dhJP = new WRAP.Data(ConfigRadar.configRadarDhJP);
          break;
        case RADAR_TYPE_KR:
          dh = this.dhKR = new WRAP.Data(ConfigRadar.configRadarDhKR);
          break;
        case RADAR_TYPE_TW:
          dh = this.dhTW = new WRAP.Data(ConfigRadar.configRadarDhTW);
          break;
        case RADAR_TYPE_US_AK:
          dh = this.dhUSAK = new WRAP.Data(ConfigRadar.configRadarDhUSAK);
          break;
        case RADAR_TYPE_US_GU:
          dh = this.dhUSGU = new WRAP.Data(ConfigRadar.configRadarDhUSGU);
          break;
        case RADAR_TYPE_US_HI:
          dh = this.dhUSHI = new WRAP.Data(ConfigRadar.configRadarDhUSHI);
          break;
        case RADAR_TYPE_US_NA:
          dh = this.dhUSNA = new WRAP.Data(ConfigRadar.configRadarDhUSNA);
          break;
        case RADAR_TYPE_US_PR:
          dh = this.dhUSPR = new WRAP.Data(ConfigRadar.configRadarDhUSPR);
          break;
        case RADAR_TYPE_CA:
          dh = this.dhCA = new WRAP.Data(ConfigRadar.configRadarDhCA);
          break;
        case RADAR_TYPE_EU:
          dh = this.dhEU = new WRAP.Data(ConfigRadar.configRadarDhEU);
          break;
        case RADAR_TYPE_AU:
          dh = this.dhAU = new WRAP.Data(ConfigRadar.configRadarDhAU);
          break;
        case RADAR_TYPE_ASIA:
        case RADAR_TYPE_US:
          promises = dataType.split('|').map(type => {
            return this.initData(type);
          });
          break;
        default:
      }

      if (dh && dh.conf.validtime) {
        dh.updated('validtime', ref => {
          this._selectValidTime(ref, dataType);
          resolve(ref);
        });
      } else if (dh) {
        dh.updated('timelist', ref => {
          this._selectValidTime(ref, dataType);
          resolve(ref);
        });
      }

      if (promises && promises.length) {
        Promise.all(promises).then(refs => {
          resolve(refs);
        });
      }

      this.areaInitialized[dataType] = true;

    });
  }

  initLayer(dataType) {
    const target = this._getTarget(dataType);
    if (Array.isArray(target.layer)){
      for (let i = 0; i < target.layer.length; i++) {
        target.layer[i].configure(target.dh[i], target.layerConfig[i]);
      }
    } else {
      target.layer.configure(target.dh, target.layerConfig);
    }
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.areaInitialized[this.dataType]) {
      await this.initialize(this.dataType);
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this._allLayers();
  }

  setVisible(visible, type) {
    if (!this.areaInitialized[this.dataType]) {
      return;
    }

    const target = this._getTarget(type);

    if (Array.isArray(target.layer)) {
      if (target.layer[0].visible() === visible) {
        return;
      }

      for (let i = 0; i < target.layer.length; i++) {
        if (visible) {
          target.layer[i].show();
        } else {
          target.layer[i].hide();
        }
        if (target.dh[i].conf.validtime) {
          target.dh[i].setAutoUpdate('validtime', visible);
        } else {
          target.dh[i].setAutoUpdate('timelist', visible);
        }
      }

    } else {
      if (target.layer.visible() === visible) {
        return;
      }

      if (visible) {
        target.layer.show();
      } else {
        target.layer.hide();
      }
      target.dh.setAutoUpdate('validtime', visible);
    }
    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
  }

  getTimeInformation() {
    let time;
    if (this.dataType === RADAR_TYPE_ASIA) {
      time = this.dataType.split('|').map(t => {
        const valid = this.areaValidtimeInfo[t];
        const time = valid !== '---' ? formatUTCDate(parseUTCDate(valid), '%Y/%m/%d %H:%MZ') : valid;
        return `${t} ${time}`
      });
    } else if (this.dataType === RADAR_TYPE_US) {
      //USのなかで最新のもの
      const valid = this.dataType.split('|').reduce( (accumulator, t) => {
        const v = this.areaValidtimeInfo[t];
        if (v !== '---' ) {
          return accumulator < v ? v : accumulator;
        }
        return accumulator
      }, '---');
      time = valid !== '---' ? formatUTCDate(parseUTCDate(valid), '%Y/%m/%d %H:%MZ') : valid;
    } else {
      const valid = this.areaValidtimeInfo[this.dataType];
      time = valid !== '---' ? formatUTCDate(parseUTCDate(valid), '%Y/%m/%d %H:%MZ') : valid;
    }
    return {
      id: Radar.NAME,
      label: 'Radar',
      baseTime: time
    }
  }

  getLegend() {
    return {
      id: Radar.NAME,
      label: 'Radar',
      component: LegendRadar,
      contents: this
    }
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.ready) return;

    this.dataType.split('|').forEach(dataType => {
      const dh = this._getTarget(dataType).dh;
      if (dh.conf.validtime) {
        this._selectValidTime(dh.retained.validtime, dataType);
      } else {
        this._selectValidTime(dh.retained.timelist, dataType);
      }
    });
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.ready) return;

    this.dataType.split('|').forEach(dataType => {
      const dh = this._getTarget(dataType).dh;
      if (dh.conf.validtime) {
        this._selectValidTime(dh.retained.validtime, dataType);
      } else {
        this._selectValidTime(dh.retained.timelist, dataType);
      }
    });
  }

  getDataType() {
    return this.dataType;
  }

  async setDataType(dataType) {
    if (dataType === this.dataType) return;

    this.changeDataTypeFlg = true;

    if (!this.areaInitialized[dataType]) {
      await this.initialize(dataType);
    }

    //現在のdataTypeを非表示
    this.setVisible(false);
    this.dataType = dataType;
    //切り替え後のdataTypeを表示
    this.setVisible(true);
  }

  getCoverage() {
    return this.coverage;
  }
  setCoverage(coverage) {
    if (this.coverage === coverage) {
      return;
    }
    this.coverage = coverage;
    this._allLayers().forEach(layer => {
      const style = coverage ? 'default' : 'clear_coverage';
      layer.setStyle(style);
    });
  }

  _selectValidTime(ref, dataType = this.dataType) {

    let timeList = ref;
    if (!timeList) return;
    timeList = timeList.validtime;

    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      targetTime = Date.now();
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    const maxValid = timeList.sort()[timeList.length - 1];
    const filterTime = parseUTCDate(maxValid).getTime() - (5 * 60 * 60 * 1000);

    const tmpTimeList = timeList.reduce((accumulator, validtime) => {
      const validSec = parseUTCDate(validtime).getTime();
      if (filterTime <= validSec) {
        accumulator.push(
          {
            "validtime": validtime,
            "validtime_msec": validSec
          }
        );
      }
      return accumulator;
    }, []);

    // targetTimeに最も近いvalidを選択する(直近が過去時制と未来時制で同時刻の場合、未来時制のValidデータを採用する。)
    const sortedTimelist = _orderBy(tmpTimeList, [
      o => {
        return Math.abs(targetTime - o.validtime_msec);
      },
      'validtime'
    ], ['asc', 'desc']);

    const selectedTime = sortedTimelist[0];

    const validTime = this.areaValidtimeInfo[dataType];

    if (selectedTime && (validTime !== selectedTime.validtime || this.changeDataTypeFlg)) {
      this.areaValidtimeInfo[dataType] = selectedTime.validtime;
      this._updateDataset(dataType);
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
    }
  }

  _updateDataset(dataType) {
    const target = this._getTarget(dataType);
    if (this.areaValidtimeInfo[dataType] !== '---') {
      target.layer.set({
        validtime: this.areaValidtimeInfo[dataType]
      });
    }
  }

  _getTarget(dataType = this.dataType) {
    let dh;
    let layer;
    let layerConfig;
    switch (dataType) {
      case RADAR_TYPE_JP:
        dh = this.dhJP;
        layer = this.layerJP;
        layerConfig = ConfigRadar.configRadarLayerJP;
        break;
      case RADAR_TYPE_KR:
        dh = this.dhKR;
        layer = this.layerKR;
        layerConfig = ConfigRadar.configRadarLayerKR;
        break;
      case RADAR_TYPE_TW:
        dh = this.dhTW;
        layer = this.layerTW;
        layerConfig = ConfigRadar.configRadarLayerTW;
        break;
      case RADAR_TYPE_US_AK:
        dh = this.dhUSAK;
        layer = this.layerUSAK;
        layerConfig = ConfigRadar.configRadarLayerUSAK;
        break;
      case RADAR_TYPE_US_GU:
        dh = this.dhUSGU;
        layer = this.layerUSGU;
        layerConfig = ConfigRadar.configRadarLayerUSGU;
        break;
      case RADAR_TYPE_US_HI:
        dh = this.dhUSHI;
        layer = this.layerUSHI;
        layerConfig = ConfigRadar.configRadarLayerUSHI;
        break;
      case RADAR_TYPE_US_NA:
        dh = this.dhUSNA;
        layer = this.layerUSNA;
        layerConfig = ConfigRadar.configRadarLayerUSNA;
        break;
      case RADAR_TYPE_US_PR:
        dh = this.dhUSPR;
        layer = this.layerUSPR;
        layerConfig = ConfigRadar.configRadarLayerUSPR;
        break;
      case RADAR_TYPE_CA:
        dh = this.dhCA;
        layer = this.layerCA;
        layerConfig = ConfigRadar.configRadarLayerCA;
        break;
      case RADAR_TYPE_EU:
        dh = this.dhEU;
        layer = this.layerEU;
        layerConfig = ConfigRadar.configRadarLayerEU;
        break;
      case RADAR_TYPE_AU:
        dh = this.dhAU;
        layer = this.layerAU;
        layerConfig = ConfigRadar.configRadarLayerAU;
        break;
      case RADAR_TYPE_ASIA:
        dh = [this.dhJP, this.dhKR, this.dhTW];
        layer = [this.layerJP, this.layerKR, this.layerTW];
        layerConfig = [ConfigRadar.configRadarLayerJP, ConfigRadar.configRadarLayerKR, ConfigRadar.configRadarLayerTW];
        break;
      case RADAR_TYPE_US:
        dh = [this.dhUSAK, this.dhUSGU, this.dhUSHI, this.dhUSNA, this.dhUSPR];
        layer = [this.layerUSAK, this.layerUSGU, this.layerUSHI, this.layerUSNA, this.layerUSPR];
        layerConfig = [ConfigRadar.configRadarLayerUSAK, ConfigRadar.configRadarLayerUSGU, ConfigRadar.configRadarLayerUSHI, ConfigRadar.configRadarLayerUSNA, ConfigRadar.configRadarLayerUSPR];
        break;
      default:
    }
    return {
      dh: dh,
      layer: layer,
      layerConfig: layerConfig
    }
  }

  _allLayers() {
    return [this.layerJP, this.layerUSAK, this.layerUSGU, this.layerUSHI, this.layerUSNA, this.layerUSPR, this.layerEU, this.layerAU, this.layerKR, this.layerTW, this.layerCA];
  }
}

export default Radar;